import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { GhiseuModuleService } from '../ghiseu-module.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ModulUpdate } from '../ghiseu-module.interface';
import { LocatiiService } from '../../locatii/locatii.service';

@Component({
    selector: 'app-edit-ghiseu-module',
    templateUrl: './edit-ghiseu-module.component.html',
    styleUrls: ['./edit-ghiseu-module.component.scss']
})
export class EditGhiseuModuleComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    locatii!: any[];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, Validators.required),
        slug: new FormControl(this.data.slug, Validators.required),
        max_programari_per_day: new FormControl(this.data.max_programari_per_day),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditGhiseuModuleComponent>,
        private ghiseuModuleService: GhiseuModuleService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private locatiiService: LocatiiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadLocatii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.ghiseuModuleService.setToken(token);
        });
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, max_programari_per_day } = this.form.value as ModulUpdate;

        const updatedModul: ModulUpdate = {
            name,
            slug,
            max_programari_per_day: max_programari_per_day || null,
            id: this.data.id,
        };

        this.ghiseuModuleService
            .updateModul(updatedModul)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
